/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetMarketMakerKPIsOptions,
  GetMarketMakerKPIsResponses,
} from '../types/GetMarketMakerKPIs'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admins and the market maker's own user. Evaluates the UTC day or month containing `at` (default now) against the daily or monthly goals. `coverage` tells how far the collector has finalized the window. `assigned` is the current assignment while unauthorized volume reflects the assignment at finalization. Depth values are the average over the window of each minute's minimum depth; /metrics reports the minimum within each bucket. meets_goal is null when undecidable: no known minutes, no goal, uptime/spread/depth while any minute of the window is not finalized, unknown, partly observed or incomplete, or a volume below goal while the window is not fully finalized, not measured from its start, or contains minutes a late event changed after they were stored (lower_bound). Without a replenishment goal, replenishment counts are reported but nothing is judged: within_goal_ratio is null.
 * @summary Market maker KPIs against goals
 * {@link /v1/market-makers/:market_maker_id/kpis}
 */
export function getMarketMakerKPIs<ThrowOnError extends boolean = true>(
  options: Options<GetMarketMakerKPIsOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetMarketMakerKPIsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers/{market_maker_id}/kpis',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetMarketMakerKPIsResponses, ThrowOnError>>,
  )
}
